import * as React from 'react';
import { connect } from 'react-redux';

import DeliverableMediaApprovalContextMenu from './context-menu/DeliverableMediaApprovalContextMenu';
import DeliverableMediaForApproval from './media-for-approval/DeliverableMediaForApproval';
import DeliverableMediaContextMenu from './deliverable-media-context-menu/DeliverableMediaContextMenu';

import { downloadFileIndividually } from 'modules/campaigns/reducers/campaignDeliverables';

import { isContentReviewed } from 'utils/deliverables';

import type { Deliverable, DeliverableAttachment, DeliverableAttachmentApprovalStatus, Subcampaign } from 'types';

type OwnProps = {
  isNewDeliverable?: boolean,
  canUpload: boolean,
  canApprove: boolean,
  allowContentMove?: boolean,
  subcampaign: Subcampaign,
  deliverable: Deliverable,
  attachment: DeliverableAttachment,
  onApprovalStatusChanged: (deliverableAttachment: DeliverableAttachment, approvalStatus: DeliverableAttachmentApprovalStatus) => void,
  onResetApprovalStatus?: (deliverableAttachments: Array<DeliverableAttachment>) => void,
  onEditMode?: () => void,
  onOpenMoveContent?: (showMoveContent: boolean) => void,
  onDeleteAttachments?: (deliverableAttachments: Array<DeliverableAttachment>) => void,
  onOpenClientApproval?: (openClientApproval?: boolean) => void,
  onApplyClientFeedback?: (deliverable: Deliverable, attachmentId?: number | null) => void
};

type DispatchProps = {
  dispatchDownloadAttachment: (
    deliverable: Deliverable,
    deliverableAttachment: DeliverableAttachment,
    isNewDeliverable?: boolean) => void
};

type Props = OwnProps & DispatchProps;

class DeliverableMediaAttachmentForApproval extends React.PureComponent<Props> {
  handleDownload = () => {
    const { attachment, deliverable, dispatchDownloadAttachment } = this.props;
    dispatchDownloadAttachment(deliverable, attachment, true);
  };

  renderContextMenu(): React.ReactNode | undefined | null {
    const { deliverable,
      subcampaign,
      canUpload,
      attachment,
      allowContentMove,
      isNewDeliverable,
      onDeleteAttachments,
      onEditMode,
      onOpenMoveContent,
      onOpenClientApproval,
      onResetApprovalStatus,
      onApplyClientFeedback } = this.props;

    const Component = isNewDeliverable ? DeliverableMediaContextMenu : DeliverableMediaApprovalContextMenu;

    return (
      <Component
        onUploadModeToggled={onEditMode}
        isBulk={false}
        subcampaign={subcampaign}
        deliverable={deliverable}
        canUpload={canUpload}
        attachments={[attachment]}
        attachment={attachment}
        allowContentMove={allowContentMove}
        hasClientAddedNewFeedback={attachment.hasClientProvidedFeedback}
        onDownloadAttachments={this.handleDownload}
        onResetApprovalStatus={isContentReviewed(attachment) ? onResetApprovalStatus : undefined}
        onDeleteAttachments={onDeleteAttachments}
        onReleaseToClient={onOpenClientApproval}
        onApplyClientFeedback={onApplyClientFeedback}
        onOpenMoveContent={onOpenMoveContent}
      />
    );
  }

  render(): React.ReactNode {
    const {
      canApprove,
      canUpload,
      attachment,
      deliverable,
      onApprovalStatusChanged
    } = this.props;
    const showButtons = canApprove && !canUpload && !isContentReviewed(attachment);

    return (
      <DeliverableMediaForApproval
        deliverableId={deliverable.id}
        showButtons={showButtons}
        showStatus={!showButtons}
        attachment={attachment}
        contextMenu={this.renderContextMenu()}
        onApprovalStatusChanged={onApprovalStatusChanged}
      />
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchDownloadAttachment: (deliverable, attachment, isNewDeliverable) =>
    dispatch(downloadFileIndividually(deliverable, attachment, isNewDeliverable))
});

export default connect(null, mapDispatchToProps)(DeliverableMediaAttachmentForApproval);
